// extracted by css-extract-rspack-plugin
export default {"cls1":"Filter-cls1_dxD","cls2":"Filter-cls2_70M Filter-cls1_dxD"};